import createIcon from '../../createIcon';

/**
 * @component @name CancelPresentation
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMTkuMUgzVjVIMjFWMTkuMVpNMjEgM0gzQzEuOSAzIDEgMy45IDEgNVYxOUMxIDIwLjEgMS45IDIxIDMgMjFIMjFDMjIuMSAyMSAyMyAyMC4xIDIzIDE5VjVDMjMgMy45IDIyLjEgMyAyMSAzWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE0LjU5IDhMMTIgMTAuNTlMOS40MSA4TDggOS40MUwxMC41OSAxMkw4IDE0LjU5TDkuNDEgMTZMMTIgMTMuNDFMMTQuNTkgMTZMMTYgMTQuNTlMMTMuNDEgMTJMMTYgOS40MUwxNC41OSA4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CancelPresentation = createIcon('CancelPresentation', [
  [
    'path',
    {
      d: 'M21 19.1H3V5H21V19.1ZM21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3Z',
      key: 'wy1fpu',
    },
  ],
  [
    'path',
    {
      d: 'M14.59 8L12 10.59L9.41 8L8 9.41L10.59 12L8 14.59L9.41 16L12 13.41L14.59 16L16 14.59L13.41 12L16 9.41L14.59 8Z',
      key: '13z1oa',
    },
  ],
]);

export default CancelPresentation;
